import useSWR from 'swr';
import commonApi from '../services/api/CommonApi';
import useAuth from './useAuth';
import { PermissionCodes } from '../utils/constants';

export const getFavItemSettingSWRKey = '/api/fav/default';
export default function useUserFavoriteSettings() {
  const { username, permissionSet } = useAuth();

  const fetcher = () => commonApi.getUserFavoriteSettings({ type: 'Default', username });

  const { data, error } = useSWR(getFavItemSettingSWRKey, fetcher, {
    revalidateOnFocus: false,
    // revalidateOnMount: false,
    revalidateOnReconnect: false,
    // refreshWhenOffline: false,
    // refreshWhenHidden: false,
    // refreshInterval: 0,
  });
  const updatedData = data?.filter((fav) => {
    if (!permissionSet[(PermissionCodes.Jobs).toLowerCase()] && !permissionSet[(PermissionCodes.Samples).toLowerCase()]) {
      return fav?.BelongsTo !== 'Job' && fav?.BelongsTo !== 'Sample';
    } if (permissionSet[(PermissionCodes.Samples).toLowerCase()] && !permissionSet[(PermissionCodes.Jobs).toLowerCase()]) {
      return fav?.BelongsTo === 'Sample';
    } if (permissionSet[(PermissionCodes.Jobs).toLowerCase()] && !permissionSet[(PermissionCodes.Samples).toLowerCase()]) {
      return fav?.BelongsTo === 'Job';
    }
    return fav;
  });

  return {
    favoriteItems: updatedData,
    isLoading: !error && !data,
    isError: error,
  };
}
